import { GradingScaleType } from '../typings/types-to-send';
import { School } from '../typings/api-types';

// null when the child's school is not in the system (API and form setters), undefined before a child is picked,
// '' for schools created by the Google Sheets import (initial_data), which never set a grading scale type
type NullableGradingScaleType = GradingScaleType | '' | null | undefined;

// If school not in system, mostly
function hasGradingScaleType(gradingScaleType: NullableGradingScaleType): boolean {
  return !!gradingScaleType;
}

function doesGradingTypeHaveGpa(gradingScaleType: NullableGradingScaleType): boolean {
  if (!hasGradingScaleType(gradingScaleType)) {
    // GPA is the one grade that can be recorded without knowing the school's grading scale
    return true;
  }
  return (
    gradingScaleType === 'GPA_ONLY' ||
    gradingScaleType === 'LETTER_AND_GPA' ||
    gradingScaleType === 'AVG_PERCENT_AND_GPA' ||
    gradingScaleType === 'AVE_PERCENT_LETTER_AND_GPA'
  );
}

function doesGradingTypeHaveLetter(gradingScaleType: NullableGradingScaleType): boolean {
  return (
    gradingScaleType === 'LETTER_AND_GPA' ||
    gradingScaleType === 'AVG_PERCENT_AND_LETTER' ||
    gradingScaleType === 'AVE_PERCENT_LETTER_AND_GPA'
  );
}

function doesGradingTypeHavePercent(gradingScaleType: NullableGradingScaleType): boolean {
  return (
    gradingScaleType === 'AVG_PERCENT_AND_LETTER' ||
    gradingScaleType === 'AVG_PERCENT_AND_GPA' ||
    gradingScaleType === 'AVE_PERCENT_LETTER_AND_GPA'
  );
}

function createLetterOptions(currentSchoolId: number | string | null | undefined, schoolData: undefined | School[]) {
  if (schoolData && currentSchoolId) {
    const school = schoolData.find((school: School) => {
      return school.id === Number(currentSchoolId);
    });
    if (school && school.grading_scale_levels) {
      return school.grading_scale_levels.map((gradingScaleLevel) => {
        return {
          label:
            gradingScaleLevel.letter_label +
            ' (' +
            gradingScaleLevel.min_percent +
            '% - ' +
            gradingScaleLevel.max_percent +
            '%)',
          value: gradingScaleLevel.letter_label,
        };
      });
    }
  }
  return [];
}

export type { NullableGradingScaleType };
export {
  hasGradingScaleType,
  doesGradingTypeHaveGpa,
  doesGradingTypeHaveLetter,
  doesGradingTypeHavePercent,
  createLetterOptions,
};
